type Row = (string | number | undefined)[]
export type CsvData = Row[]

// csv: 2次元配列
// [
//   [1, 2, 3],
//   [4, 5, 6]
// ]
// content: 1,2,3\n4,5,6
function csvToContent(csv: CsvData) {
  return csv.map(row => row.join(',')).join('\n')
}

function createElement(url: string, name: string) {
  const $a = document.createElement('a')
  $a.download = name
  $a.href = url

  return $a
}

function download(csv: CsvData, name: string) {
  const bom = new Uint8Array([0xef, 0xbb, 0xbf])
  const content = csvToContent(csv)
  const blob = new Blob([bom, content], { type: 'text/csv' })
  const url = window.URL.createObjectURL(blob)
  const $a = createElement(url, name)

  $a.click()
}

export default { download }
